/**
 * @file 获取单个学员问卷提交信息
 * @author liudy
 * @see http://api.umucdn.cn/project/106/wiki
 */

import Api from '../../path';
import { PollType } from '@umu/umu-types';
import { fetchData, fetchDataSync } from '@umu/umu-fetch';

export interface IGetPollUserResultInput {
    parent_id: number; // int 作业问卷ID
    parent_type: PollType; // int 1、保存作业多维度评价问卷模板 2、保存作业多维度评价问卷
    obj_id: number; // int 评价对象ID，比如学生提交作业的homework_id
    student_id: number; // int 学员id，未登录用户会用负数，这个参数会在获取列表时返回
}

// tslint:disable-next-line:max-line-length
export const getPollUserResult = (data: IGetPollUserResultInput): Promise<IResponse<IServerUserResultMap>> => {
    return fetchData(Api.POLL_USER_RESULT, data).then((res: IResponse<IServerUserResultMap>) => {
        return res;
    });
};

export const getPollUserResultSync = fetchDataSync(getPollUserResult);
